import React from 'react';
import PropTypes from 'prop-types';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import { useTranslation } from 'utils/modifiedTranslation';
import { geoActions } from 'utils/actions/geo';
import CustomGeoSuggestField from 'components/CustomGeoSuggestField';
import Card from 'components/Card';

const Location = props => {
  const { item, geoLocation, rootClassName, inputClassName } = props;
  const { t } = useTranslation();

  React.useEffect(() => {
    if (geoLocation && geoLocation.location) {
      const { label, location } = geoLocation;
      onSelect({
        label,
        location: {
          lat: location.lat,
          lng: location.lng
        }
      });
    }
    // eslint-disable-next-line
  }, []);

  const onSelect = item => {
    if (item && item.location) {
      const value = {
        location: item.location,
        label: item.label
      };
      props.setUserGeoLocation(value);
      if (typeof props.onChange === 'function') {
        props.onChange(value);
      }
    }
  };

  return (
    <Card key={item.id} className={rootClassName}>
      <CustomGeoSuggestField
        inputClassName={inputClassName}
        initialValue={t(geoLocation.label) || ''}
        onChange={onSelect}
        placeholder="change_location.geo_suggest.placeholder"
      />
    </Card>
  );
};

Location.propTypes = {
  setUserGeoLocation: PropTypes.func.isRequired,
  geoLocation: PropTypes.shape({
    label: PropTypes.string,
    location: PropTypes.shape({
      lng: PropTypes.number.isRequired,
      lat: PropTypes.number.isRequired,
    }),
  }),
  item: PropTypes.object,
  /**
   * Classname for the root div
   */
  rootClassName: PropTypes.string,
  inputClassName: PropTypes.string
};

Location.defaultProps = {
  geoLocation: {},
  item: {},
  rootClassName: ''
};

const mapStateToProps = state => ({
  geoLocation: state.geo_location
});

const mapDispatchToProps = dispatch => ({
  setUserGeoLocation: geoObject => dispatch(geoActions.setGeoLocation(geoObject))
});

export default Redux.compose(connect(mapStateToProps, mapDispatchToProps))(Location);
